import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionCardProps {
  title: string;
  subtitle: string;
  open: boolean;
  onToggle: () => void;
  error?: string;
  sectionLabel?: string;
  children: React.ReactNode;
}
export function AccordionCard({
  title,
  subtitle,
  open,
  onToggle,
  error,
  sectionLabel,
  children
}: AccordionCardProps) {
  return <section className={`rounded-lg border bg-white ${error ? 'border-red-400' : 'border-ink-200'}`} data-id="element-291" data-mp="2j37didcxgayx">
      <button type="button" onClick={onToggle} aria-expanded={open} className="flex w-full items-center justify-between gap-4 px-6 py-4 text-left" data-id="element-292" data-mp="2o1ioireykriq">
        <span className="min-w-0" data-id="element-293" data-mp="2x2gv9hgs7d50">
          <span className="block truncate text-[14px] font-bold text-ink-900" data-id="element-294" data-mp="2x3i5xktvxxm7">{title}</span>
          <span className="mt-0.5 block truncate text-[13px] text-ink-500" data-id="element-295" data-mp="89utj1ji992k">{subtitle}</span>
          {error && <span className="mt-1 block text-[12.5px] font-medium text-red-600" data-id="element-296" data-mp="cbgela670tnu">{error}</span>}
        </span>
        <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${open ? 'bg-ink-100 text-ink-600' : 'bg-ink-50 text-ink-500'}`} data-id="element-297" data-mp="6vddazplkec7">
          <ChevronDownIcon className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-298" data-mp="3t2laheqd5ex5" />
        </span>
      </button>
      {open && <div className="flex flex-col gap-4 px-6 pb-6 sm:flex-row sm:gap-8" data-id="element-299" data-mp="3k37z2gioig9s">
          {sectionLabel && <p className="w-[220px] shrink-0 pt-1 text-[13px] font-bold text-ink-900" data-id="element-300" data-mp="3fcrnl1yf54q2">{sectionLabel}</p>}
          <div className="min-w-0 flex-1" data-id="element-301" data-mp="3acvewpes0p46">{children}</div>
        </div>}
    </section>;
}